export const PRIVACY_HOME = '/myaccount/privacy'
export const DAR_SUBMIT_URL = '/myaccount/privacy/data/api/dar/createcase'
export const DATA_DELETION_SUBMIT_URL =
  '/myaccount/privacy/data/api/deletion/createcase'
export const DAR_SMC_DOWNLOAD_URL = '/smc/async/home?isvenice=false'
export const DAR_SMC_DOWNLOAD_URL_NATIVE = '/smc/async/home?isvenice=true'
export const DATA_CORRECTION_ACCOUNT_URL = '/myaccount/settings'
export const DATA_CORRECTION_WALLET_URL = '/myaccount/money/'
export const DATA_CORRECTION_ACCOUNT_NATIVE =
  'paypal://optiondetails_personalinfo'
export const DATA_CORRECTION_WALLET_NATIVE = 'paypal://cards'
export const DATA_CORRECTION_WALLET_NATIVE_ANDROID =
  'paypal://options_details_wallet_details'
export const DATA_DELETION_EMAILPAGE = '/myaccount/privacy/data/deletion/email'
export const DATA_DELETION_FEEDBACK =
  '/myaccount/privacy/data/deletion/feedback'
export const DATA_DELETION_EMAIL_SUBMIT =
  '/myaccount/privacy/data/deletion/emailsubmit'
export const DATA_DAR_CREATE_URL = '/myaccount/privacy/data/dar'
export const DATA_DAR_ACTIVITY_DOWNLOAD_PERSONAL = '/reports/dlog'
export const DATA_DAR_ACTIVITY_DOWNLOAD_BUSINESS = '/reports'
export const DATA_DAR_ACTIVITY_DOWNLOAD_PERSONAL_NATIVE =
  '/reports/dlog?headerLessMode=true'
export const DATA_DAR_ACTIVITY_DOWNLOAD_BUSINESS_NATIVE =
  '/reports?headerLessMode=true'
export const PYPL_CONTACTUS_URL = '/smarthelp/contact-us'
export const PRIVACY_MERCHANT_HOME_FROM_DAR =
  '/businessmanage/profile/dataprivacy'
export const PRIVACY_STATEMENT = '/webapps/mpp/ua/privacy-full'
export const PYPL_SAFETY_SECURITY = '/webapps/mpp/paypal-safety-and-security'
export const PRIVACY_FORM = '/smarthelp/contact-us/privacy'
export const NOTIFICSTION_SETTINGS =
  '/myaccount/privacy/data/notifications/redirect'
export const PYPL_SECURITY_SETTINGS =
  '/myaccount/privacy/data/security/redirect'
export const SEARCH_PRIVACY_API = '/myaccount/privacy/profiles/search/api'
export const MERCHANT_DATA_CORRECTION_BUSINESS_URL =
  '/businessprofile/settings/info/edit'
export const MERCHANT_DATA_CORRECTION_ACCOUNT_URL =
  '/businessmanage/account/accountOwner'
export const MERCHANT_DATA_CORRECTION_FINANCE_URL =
  '/businessmanage/account/money'
export const ZETTLE_SUBMIT_API = '/myaccount/privacy/zettle/api/createcase'
export const ZETTLE_SUBMIT_GLOBAL_API =
  '/myaccount/privacy/zettle/api/global/createcase'

export const ZETTLE_VERIFICATION_API =
  '/myaccount/privacy/zettle/api/verifycase'
export const ZETTLE_US_URL = '/myaccount/privacy/zettle/'
export const ZETTLE_GLOBAL_VERIFICATION_API =
  '/myaccount/privacy/zettle/api/global/verifycase'
export const ZETTLE_GLOBAL_URL = '/myaccount/privacy/zettle/global'
export const ZETTLE_EU_URL = 'https://www.zettle.com/privacy-portal'
export const PRIVACY_STATEMENT_LINK = '/en/webapps/mpp/ua/privacy-full'
export const SHOPPING_PRIVACY_FLOW_REDESIGN =
  '/myaccount/privacy/settings/paypalShopping/personalize'
export const SHOPPING_NOTIFICATIONS_MARKETING =
  '/myaccount/preferences/notifications/marketing'
export const SHOPPING_API = '/myaccount/privacy/settings/paypalShopping/api'
export const PYPL_SMARTHELP_HOME_URL = '/smarthelp/home'
export const PERSONALIZATION_API = '/myaccount/privacy/settings/personalization'
export const SESSION_TIMEOUT = 3000
export const SIGNUP_LINK = '/webapps/mpp/account-selection'
export const RETRIGGER_PASSWORD_API =
  '/myaccount/privacy/retrigger-sms/api/trigger-password'
export const LOGGEDOUT_CREATE_CASE_API =
  '/myaccount/privacy/common/pypl/api/createcase'
export const LOGGEDOUT_VERIFICATION_API =
  '/myaccount/privacy/common/pypl/api/emailverification'
export const LOGGEDOUT_TRACK_REQUEST_API =
  '/myaccount/privacy/common/pypl/api/trackrequest'
export const PP_LOGGED_OUT_URL = '/myaccount/privacy/common/pypl'
export const PASSWORD_RECOVERY_API =
  '/myaccount/privacy/common/password-recovery/api/trigger-password'
export const VENMOPAGE = 'https://venmo.com/'
export const VENMO_CONTACTUS =
  'https://help.venmo.com/hc/en-us/requests/new?ticket_form_id=624807'
export const VENMO_RESUBMIT =
  'https://account.venmo.com/settings/privacy/report'
export const PRIVACY_HUB = '/myaccount/privacy/privacyhub'
export const PRIVACY_HOME_MERCHANT_NATIVE =
  '/myaccount/privacy/merchant?inframe=yes'
export const PRIVACY_STATEMENT_QL_URL = '/us/legalhub/privacy-full'
export const PRIVACY_STATES_QL_URL = '/us/legalhub/privacy-states'

//FPTI Constants
export const MERCHANT_DATA_PRIVACY = 'main:businessweb:profile:dataprivacy'
export const DATA_PRIVACY_HOME = 'main:dataprivacy:home'
export const DATA_PRIVACY_MANAGECOOKIES = 'main:dataprivacy:home|manage_cookies'
export const MERCHANT_DATA_PRIVACY_MANAGECOOKIES =
  'main:businessweb:profile:dataprivacy|manage_cookies'
export const DATA_PRIVACY_PROFILE_SEARCH =
  'main:businessweb:profile:dataprivacy|profiles_search'
export const DATA_PRIVACY_HOME_PROFILE_SEARCH =
  'main:dataprivacy:home|profiles_search'
export const MERCHANT_DATA_PRIVACY_BLOCKED_CONTACTS =
  'main:businessweb:profile:dataprivacy|blocked_contacts'
export const DATA_PRIVACY_HOME_BLOCKED_CONTACTS =
  'main:dataprivacy:home|blocked_contacts'
export const DATA_PRIVACY_PERSONALIZATION_PAYPAL =
  'main:dataprivacy:personalization:paypal'
export const DATA_PRIVACY_PERSONALIZATION_PAYPAL_TOGGLE =
  'main:dataprivacy:personalization:paypal:toggle'
export const DATA_PRIVACY_PERSONALIZATION_OTHER =
  'main:dataprivacy:personalization:other'
export const DATA_PRIVACY_PERSONALIZATION_OTHER_TOGGLE =
  'main:dataprivacy:personalization:other:toggle'
export const DATA_PRIVACY_SHOPPING = 'main:dataprivacy:shopping'
export const DATA_PRIVACY_SHOPPING_SUCCESS = 'main:dataprivacy:shopping:success'
export const MERCHANT_DATA_PRIVACY_CORRECT_DATA =
  'main:businessweb:profile:dataprivacy|correct_data'
export const MERCHANT_DATA_PRIVACY_DOWNLOAD_DATA =
  'main:businessweb:profile:dataprivacy|download_data'
export const MERCHANT_DATA_PRIVACY_DELETE_DATA =
  'main:businessweb:profile:dataprivacy|delete_data'
export const DATA_PRIVACY_HOME_CORRECT_DATA =
  'main:dataprivacy:home|correct_data'
export const DATA_PRIVACY_HOME_DOWNLOAD_DATA =
  'main:dataprivacy:home|download_data'
export const DATA_PRIVACY_HOME_DELETE_DATA = 'main:dataprivacy:home|delete_data'
export const DATA_DELETION_LINKED_ACCOUNTS_API =
  '/myaccount/privacy/data/api/deletion/linked-accounts'
export const DOWNLOAD_DATA = 'main:dataprivacy:downloaddata'
export const DOWNLOAD_DATA_SUCCESS = 'main:dataprivacy:downloaddata:success'
export const DATA_REQUEST = 'main:dataprivacy:datarequest'
export const DATA_CORRECTION = 'main:dataprivacy:datacorrection'
export const DATA_DELETION = 'main:dataprivacy:datadelettion'
export const DATA_DELETION_SUCCESS = 'main:dataprivacy:datadelettion:success'
export const DATA_DELETION_EMAIL = 'main:dataprivacy:datadelettion:email'
export const DATA_DELETION_SURVEY = 'main:dataprivacy:datadelettion:survey'
export const ZETTLE_DSR = 'main:dataprivacy:zettledsr'
export const ZETTLE_DSR_CASECREATION = 'main:dataprivacy:zettledsr:casecreation'
export const ZETTLE_DSR_SUCCESS = 'main:dataprivacy:zettledsr:success'
export const ZETTLE_DSR_EMAILVERIFICATION =
  'main:dataprivacy:zettledsr:emailverification'
export const ZETTLE_EMAIL_VERIFICATIONSUCCESS =
  'main:dataprivacy:zettledsr:emailverification:success'
export const ZETTLE_EMAIL_VERIFICATIONEXPIRED =
  'main:dataprivacy:zettledsr:emailverification:expired'
export const ZETTLE_EMAIL_VERIFICATIONERROR =
  'main:dataprivacy:zettledsr:emailverification:error'
export const ZETTLE_EMAIL_VERIFICATIONCLOSED =
  'main:dataprivacy:zettledsr:emailverification:closed'
export const DATA_PRIVACY_CLOSEDACCOUNT = 'main:dataprivacy:closedaccount'
export const CLOSED_ACCOUNT_SMSSENT = 'main:dataprivacy:closedaccount_smssent'
export const CLOSED_ACCOUNT_LINKEXPIRED =
  'main:dataprivacy:closedaccount:linkexpired'
export const CLOSED_ACCOUNT_SOMETHINGWRONG =
  'main:dataprivacy:closedaccount:somethingwentwrong'
export const DOWNLOAD_OTHERINFO = 'main:dataprivacy:downloaddata:otherinfo'
export const DOWNLOAD_OTHERINFOTT =
  'main:dataprivacy:downloaddata:otherinfotooltip'
export const DP_PROFILES_SEARCH = 'main:dataprivacy:profiles:search'

export const LOGGED_OUT_WELCOME = 'main:dataprivacy:loggedout:welcome'
export const LOGGED_OUT_START_REQUEST_BTN =
  'main:dataprivacy:loggedout:startrequestwelcome'
export const LOGGED_OUT_ALREADY_REQUESTED_LINK =
  'main:dataprivacy:loggedout:alreadyrequestedlink'
export const LOGGED_OUT_MANAGE_YOUR_DATA =
  'main:dataprivacy:loggedout:manageyourdata'
export const LOGGED_OUT_CREATE_REQUEST_BTN =
  'main:dataprivacy:loggedout:startrequest'
export const LOGGED_OUT_CREATE_REQUEST =
  'main:dataprivacy:loggedout:create_data_request'
export const LOGGED_OUT_CONFIRM_MAIL =
  'main:dataprivacy:loggedout:confirm_your_mail'
export const LOGGED_OUT_TRACK_REQUEST =
  'main:dataprivacy:loggedout:track_your_data_request'
export const LOGGED_OUT_QUICK_SECURITY =
  'main:dataprivacy:loggedout:quick_security'
export const LOGGED_OUT_OTP_CODE = 'main:dataprivacy:loggedout:enter_your_code'
export const LOGGED_OUT_STATUS = 'main:dataprivacy:loggedout:status'
export const LOGGED_OUT_THANKS_REQUEST =
  'main:dataprivacy:loggedout:thanks_for_request'
export const LOGGED_OUT_LINK_EXPIRED = 'main:dataprivacy:loggedout:link_expired'
export const LOGGED_OUT_EMAIL_NOT_CONFIRMED =
  'main:dataprivacy:loggedout:email_link_could_not_be_confirmed'
export const LOGGED_OUT_VERIFICATION_CLOSED =
  'main:dataprivacy:loggedout:verification_closed'

export const LINKED_ACC_FOUND =
  'main:dataprivacy:linkedaccounts:linkedaccounts-found'
export const LINKED_ACC_PAGE = 'main:dataprivacy:linkedaccounts'

export const FACESCAN_PAGE = 'main:dataprivacy:facescan'
export const FACESCAN_PAGE_MOVE_BTN =
  'main:dataprivacy:facescan:faceScanMoveBackBtn'
export const RECOMMENDATIONS_PAGE = 'main:dataprivacy:recommendations'

export const FACESCAN_PAGE_DELETE_BTN =
  'main:dataprivacy:facescan|deleteFaceScanData'

export const FACESCAN_PAGE_CONFIRM_DELETE_BTN =
  'main:dataprivacy:facescan|confirmDeleteFaceScanData'

export const VENMO_PASSWORD_SENT = 'main:dataprivacy:venmo:passwordsent'
export const VENMO_PASSWORD_WRONG = 'main:dataprivacy:venmo:somethingwrong'
export const VENMO_PASSWORD_EXPIRED = 'main:dataprivacy:venmo:linkexpired'

export const PREVENT_DUPLICATE_ERASURE_IN_PROGRESS =
  'main:dataprivacy:prevent_duplicate_erasure:inprogress'
export const PREVENT_DUPLICATE_ERASURE_UN_RESOLVED =
  'main:dataprivacy:prevent_duplicate_erasure:unresolved'
export const PREVENT_DUPLICATE_ERASURE_MAKE_REQUEST =
  'main:dataprivacy:prevent_duplicate_erasure:makerequest'
export const PRIVACY_MERCHANT_COMPONENT = 'bizmanagenodeweb'
export const PRIVACY_CONSUMER_COMPONENT = 'privacynodeweb'
export const DATA_PRIVACY_FACE_SCAN = 'main:dataprivacy:home|manage_face_scan'
export const MERCHANT_DATA_PRIVACY_DAR_REQUEST =
  'main:businessweb:profile:dataprivacy|your_request'
export const DATA_PRIVACY_HOME_DAR_REQUEST =
  'main:dataprivacy:home|your_request'
export const SURVEY_EVENT_NAME_DAR =
  'privacynodeweb-active-confirmation-download-mar2024-web'
export const SURVEY_EVENT_NAME_DER =
  'privacynodeweb-active-confirmation-delete-mar2024-web'
export const DATA_PRIVACY_SHARED_RECOMMENDATIONS =
  'main:dataprivacy:home:shared_recommendations'
